// Grizzly Co: allow only one <details> open at a time within a product accordion group
document.addEventListener('click', (event) => {
  const summary = event.target.closest('summary');
  if (!summary) return;

  const details = summary.closest('details');
  if (!details) return;

  // Only target product accordions
  const accordionWrap = details.closest('.product__accordion');
  if (!accordionWrap) return;

  // Wait for the browser to toggle <details open> after the click
  requestAnimationFrame(() => {
    if (!details.open) return;

    // Scope: the whole product info area (so it closes other accordion blocks too)
    const scope =
      details.closest('.product__info-wrapper') ||
      details.closest('.product__info-container') ||
      details.closest('section') ||
      document;

    const allDetails = scope.querySelectorAll('.product__accordion details');

    allDetails.forEach((d) => {
      if (d !== details) d.removeAttribute('open');
    });
  });
});
